export const testNumber = (num: string) => {
  return REGEXP.NUMBER.test(num)
}

export const testPhone = (value: string) => {
  return REGEXP.PHONE.test(value)
}

export const testPassword = (value: string) => {
  return REGEXP.PASSWORD.test(value)
}

export const testYyyymmdd = (value: string) => {
  return REGEXP.YYYYMMDD.test(value)
}

export const testCorporateRegistrationNumber = (value: string) => {
  return REGEXP.CORPORATE_REGISTRATION_NUMBER.test(value)
}

export const testResidentRegistrationNumber = (value: string) => {
  return REGEXP.RESIDENT_REGISTRATION_NUMBER.test(value)
}

export const testCompanyRegistrationNumber = (value: string) => {
  return REGEXP.COMPANY_REGISTRATION_NUMBER.test(value)
}
